/* „További termékek" — AJAX-append oldalnavigáció helyett.

   Miért: navigációval a böngésző a lap tetejére ugrik, és a vásárló
   elveszti, hol tartott. Itt a következő oldal termékei a meglévő rács
   VÉGÉRE kerülnek, a görgetési pozíció nem mozdul.

   Progresszív: a gomb valódi <a href="?page=N">, tehát JS nélkül is
   működik navigációként. A szkript csak elfogja a kattintást.

   VISSZATÉRÉS (2026-09-04): ha a vásárló betöltött több oldalt, majd
   megnyitott egy terméket és visszalép, a böngésző a `?page=N` címet
   tölti be — ott a szerver CSAK az N. oldalt rendereli, a lap
   tetejéről. Mérve: 40 betöltött termékből 8 maradt, a görgetés 0-n.
   Ezért kilépéskor eltesszük, hol tartott (munkamenet-tár), és
   visszatéréskor az 1..N-1. oldalt a meglévő elé fűzzük, majd
   visszaállítjuk a görgetést. Csak akkor, ha ugyanabban a böngésző-
   munkamenetben ugyanezen a listán tényleg fűzött hozzá — megosztott
   linkről érkezőnek nem csinálunk semmit. */
(function () {
  'use strict';

  var SELECTOR = '[data-pm-loadmore]';
  var TAR_ELOTAG = 'pmLoadMore:';
  var ERVENYES_MS = 30 * 60 * 1000;
  var pushedAny = false;
  var visszaallitva = false;

  /* A racsot a doboz SAJAT szekciojabol vesszuk, nem a lap elso
     .product-grid elemebol: ha valaha kerul a lista fole egy masik
     termekracs (kiemelt termekek, masodik lista), a globalis kereses azt
     talalna meg, es oda fuzne be a termekeket. */
  function racs(box) {
    var szekcio = box.closest('.shopify-section');
    return (szekcio || document).querySelector('.product-grid');
  }

  function parseIntSafe(v, fallback) {
    var n = parseInt(v, 10);
    return isFinite(n) ? n : fallback;
  }

  function updateProgress(box) {
    var total = parseIntSafe(box.dataset.total, 0);
    var loaded = parseIntSafe(box.dataset.loaded, 0);
    var countEl = box.querySelector('.pm-pagination__count');
    var fillEl = box.querySelector('.pm-pagination__fill');

    /* A felirat azt mondja, ami tényleg a képernyőn van. Az első
       oldalról indulva halmozott ("32 / 40 termék"), mert a lista az
       elejétől áll. Ha a látogató egyenesen egy ?page=N címre érkezett,
       a kezdet nem 1, ezért tartomány marad ("17–40 / 40 termék") — a
       lista eleje ott tényleg nincs a képernyőn. */
    var start = parseIntSafe(box.dataset.rangeStart, 1);
    if (countEl) {
      countEl.textContent =
        start > 1
          ? start + '–' + loaded + ' / ' + total + ' termék'
          : loaded + ' / ' + total + ' termék';
    }
    if (fillEl && total > 0) fillEl.style.width = Math.round((loaded / total) * 100) + '%';
  }

  /* ---- visszatérés: hol tartott a vásárló ---------------------------- */

  function oldalSzam() {
    return parseIntSafe(new URLSearchParams(location.search).get('page'), 1);
  }

  /* A kulcs a listához tartozik, nem az oldalszámhoz: szűrő/rendezés
     más lista, tehát más kulcs, de a ?page= nem számít bele. */
  function tarKulcs() {
    var p = new URLSearchParams(location.search);
    p.delete('page');
    var q = p.toString();
    return TAR_ELOTAG + location.pathname + (q ? '?' + q : '');
  }

  function allapotMent() {
    if (!pushedAny && !visszaallitva) return;
    try {
      sessionStorage.setItem(
        tarKulcs(),
        JSON.stringify({
          oldal: oldalSzam(),
          scroll: Math.round(document.scrollingElement.scrollTop),
          ido: Date.now()
        })
      );
    } catch (e) {
      /* privát mód: a lista attól még jó, csak nem áll helyre */
    }
  }

  function allapotOlvas() {
    try {
      var nyers = sessionStorage.getItem(tarKulcs());
      if (!nyers) return null;
      var a = JSON.parse(nyers);
      if (!a || !a.ido || Date.now() - a.ido > ERVENYES_MS) return null;
      return a;
    } catch (e) {
      return null;
    }
  }

  function oldalUrl(i) {
    var p = new URLSearchParams(location.search);
    if (i <= 1) p.delete('page');
    else p.set('page', i);
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  function oldalKeres(i) {
    return fetch(oldalUrl(i), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) {
        if (!res.ok) throw new Error('page-failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('.product-grid');
        if (!grid) return [];
        return Array.prototype.slice.call(grid.querySelectorAll(':scope > li')).map(function (li) {
          return document.importNode(li, true);
        });
      });
  }

  /* A görgetést a betűk betöltése UTÁN állítjuk vissza, két képkockán
     át: a lap magassága addig még változhat, és a böngésző saját
     helyreállítási kísérlete is belenyúlhat. */
  function gorgetesVissza(cel) {
    if (!cel) return;
    function alkalmaz() {
      var se = document.scrollingElement;
      var max = se.scrollHeight - window.innerHeight;
      var hova = Math.max(0, Math.min(cel, max));
      /* A témában `scroll-behavior: smooth` van a gyökéren (mérve), így a
         sima `scrollTop =` végiganimálná a teljes listát. Helyreállításnál
         ez zavaró és megszakítható, ezért kifejezetten azonnali. */
      try {
        window.scrollTo({ top: hova, behavior: 'instant' });
      } catch (e) {
        se.scrollTop = hova;
      }
    }
    /* Többször is nekifutunk, és NEM csak requestAnimationFrame-ből: az
       rAF háttérbe került fülön nem fut le (mérve: a helyreállítás
       megtörtént, a görgetés mégis 0 maradt, mert a callback soha nem
       hívódott meg). Az azonnali hívás + időzítő attól is működik. */
    alkalmaz();
    var kesz = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    kesz.then(function () {
      alkalmaz();
      requestAnimationFrame(alkalmaz);
    });
    setTimeout(alkalmaz, 150);
    setTimeout(alkalmaz, 600);
  }

  function visszaallit(box, allapot) {
    var oldal = oldalSzam();
    // Csak oda állítunk helyre, ahonnan elment, és csak ha van mit elé fűzni.
    if (oldal < 2 || allapot.oldal !== oldal) return;

    var grid = racs(box);
    if (!grid) return;

    var kerések = [];
    for (var i = 1; i < oldal; i++) kerések.push(oldalKeres(i));

    box.dataset.pmBusy = '1';
    Promise.all(kerések)
      .then(function (listak) {
        var frag = document.createDocumentFragment();
        var db = 0;
        listak.forEach(function (elemek) {
          elemek.forEach(function (li) {
            frag.appendChild(li);
            db++;
          });
        });
        grid.insertBefore(frag, grid.firstElementChild);

        /* A `data-loaded` a szerveren a tartomány VÉGE (pl. a 3. oldalon
           40), tehát az elé fűzés után pont a teljes listát írja le — a
           kezdet viszont már 1, ezért a felirat halmozottra vált. */
        box.dataset.rangeStart = '1';
        updateProgress(box);

        try {
          document.dispatchEvent(new CustomEvent('pm:wishlist-change'));
          document.dispatchEvent(new CustomEvent('pm:products-appended', { detail: { count: db } }));
        } catch (e) {
          /* egy hibás figyelő ne buktassa a helyreállítást */
        }

        visszaallitva = true;
        box.dataset.pmBusy = '0';
        gorgetesVissza(allapot.scroll);
      })
      .catch(function () {
        // Nem sikerült: marad a szerver által renderelt oldal, ez nem hiba.
        box.dataset.pmBusy = '0';
      });
  }

  function announce(box, message) {
    var live = box.querySelector('[data-pm-loadmore-live]');
    if (live) live.textContent = message;
  }

  function load(box, btn) {
    var next = btn.getAttribute('href');
    if (!next || box.dataset.pmBusy === '1') return;

    box.dataset.pmBusy = '1';
    var original = btn.textContent;
    btn.textContent = 'Betöltés…';
    btn.setAttribute('aria-busy', 'true');

    fetch(next, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (res) {
        if (!res.ok) throw new Error('load-more-failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var currentGrid = racs(box);
        var nextGrid = doc.querySelector('.product-grid');
        if (!currentGrid || !nextGrid) throw new Error('grid-missing');

        var items = nextGrid.querySelectorAll(':scope > li');
        var added = 0;
        items.forEach(function (li) {
          currentGrid.appendChild(document.importNode(li, true));
          added++;
        });

        box.dataset.loaded = parseIntSafe(box.dataset.loaded, 0) + added;
        updateProgress(box);

        // A következő oldal gombja a frissen betöltött lapról jön.
        var nextBtn = doc.querySelector(SELECTOR + ' .pm-pagination__btn');
        if (nextBtn && nextBtn.getAttribute('href')) {
          btn.setAttribute('href', nextBtn.getAttribute('href'));
          btn.textContent = original;
          btn.removeAttribute('aria-busy');
        } else {
          // Nincs több termék: a gomb eltűnik.
          btn.remove();
        }

        // A böngésző vissza/előre gombja ne törjön el: az URL követi,
        // hol tartunk, de a lap nem töltődik újra.
        try {
          history.pushState({ pmPage: next }, '', next);
          pushedAny = true;
          utolsoCim = location.href;
        } catch (e) {
          /* privát mód vagy blokkolt history — a lista attól még jó */
        }

        /* A mellékhatások SAJÁT try/catch-ben: ezek az események szinkron
           módon futtatják más szkriptek kezelőit, és ha bármelyik kivételt
           dob, a lenti .catch() ág futna le — az pedig elnavigálna a
           ?page=N címre, holott a termékek már sikeresen bekerültek. A
           vásárló a lap tetején, 16 termékkel találná magát. */
        try {
          // A kedvenc-gombok kitöltött/üres állapotát szinkronizálni kell:
          // a kattintás delegált, de az induló állapot nem.
          document.dispatchEvent(new CustomEvent('pm:wishlist-change'));
          // Jelzés minden olyan szkriptnek, ami utólag beszúrt kártyákra épít.
          document.dispatchEvent(new CustomEvent('pm:products-appended', { detail: { count: added } }));
          announce(box, added + ' további termék betöltve.');
        } catch (e) {
          /* egy hibás figyelő nem viheti el a sikeres betöltést */
        }
        box.dataset.pmBusy = '0';
      })
      .catch(function () {
        // Hiba esetén visszaadjuk a navigációt: a gomb marad valódi link.
        btn.textContent = original;
        btn.removeAttribute('aria-busy');
        box.dataset.pmBusy = '0';
        window.location.href = next;
      });
  }

  /* Vissza/előre gomb. pushState után a DOM nem követi automatikusan a
     history-t: MÉRVE, hogy a vissza-gomb után az URL ?page=2 lett,
     miközben a listában maradt mind a 40 kártya és a "40 / 40" felirat.
     Ilyenkor újratöltünk, hogy az URL és a tartalom mindig egyezzen.

     DE csak akkor, ha a popstate TÉNYLEG a lapozásról szól. A téma több
     helyen is tol be history-állapotot ugyanerre a lapra, URL-változás
     nélkül: a kosár-drawer (assets/cart-drawer.js), a mézválasztó
     (assets/pm-honey-finder.js), és URL-lel a szűrők (assets/facets.js).
     Mérve 2026-09-05-én: egyetlen „További termékek" kattintás után a
     drawer bezárása a vissza gombbal TELJES oldalújratöltést váltott ki
     (navigation type = reload). Ezért most összevetjük a címet: csak
     akkor töltünk újra, ha kizárólag a `page` paraméter változott. */
  function oldalNelkuliCim(cim) {
    var u = new URL(cim, location.href);
    u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  function oldalParam(cim) {
    return new URL(cim, location.href).searchParams.get('page') || '1';
  }

  var utolsoCim = location.href;

  window.addEventListener('popstate', function () {
    var uj = location.href;
    var regi = utolsoCim;
    utolsoCim = uj;
    if (!pushedAny) return;
    // Ugyanaz a cím: valaki más (drawer, mézválasztó) tolt be állapotot.
    if (uj === regi) return;
    // Szűrő/rendezés változott: azt a téma saját kezelője rendereli újra.
    if (oldalNelkuliCim(uj) !== oldalNelkuliCim(regi)) return;
    if (oldalParam(uj) === oldalParam(regi)) return;
    window.location.reload();
  });

  function init(box) {
    if (box.dataset.pmLoadmoreInit) return;
    box.dataset.pmLoadmoreInit = '1';

    /* Induláskor NEM írjuk át a feliratot: a szerver már a helyeset
       rendereli, és a JS-változat itt hazudott. Mérve 2026-09-04-én:
       friss ?page=2-n 16 termék fölött "32 / 40", a vissza gomb utáni
       ?page=3-on 8 termék fölött "40 / 40 termék" tele csíkkal és gomb
       nélkül — zsákutca. A felirat mostantól csak tényleges hozzáfűzés
       után frissül. */

    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.pm-pagination__btn');
      if (!btn) return;
      e.preventDefault();
      load(box, btn);
    });

    // Kilépéskor eltesszük, hol tartott; visszatéréskor helyreállítjuk.
    window.addEventListener('pagehide', allapotMent);
    var allapot = allapotOlvas();
    if (allapot) visszaallit(box, allapot);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // 2026-09-13 (audit KOD-05): Theme Editor szekcio-ujrarender utan is (a data-*Init orszem vedi a dupla kotest).
  document.addEventListener('shopify:section:load', initAll);
})();